import Vue from 'vue';
import _ from 'lodash';

const store = {
    namespaced: true,

    state: {
        isVisible: true,
        isDetailsShown: false,
        items: {},
        seeThrough: false
    },

    mutations: {
        ADD: function (state, payload) {
            Vue.set(state.items, payload.id, {
                id: payload.id,
                location: payload.location
            });
            Vue.set(state.items[payload.id], 'info', payload.info);
        },

        REMOVE: function (state, id) {
            Vue.delete(state.items, id);
        },

        SET_VISIBILITY: function (state, isVisible) {
            state.isVisible = isVisible;
        },

        SET_SHOW_DETAILS: function (state, isShown) {
            state.isDetailsShown = isShown;
        },

        DELETE_FOR_AUTHOR: function (state, { authorId, excludeHelperObjects = false }) {
            if (excludeHelperObjects) {
                state.items = _.omitBy(state.items, item => item.info.authorId === authorId && modelManager.getModelType(item.location.modelId) !== ModelTypeEnum.HELPER_OBJECT);
            } else {
                state.items = _.omitBy(state.items, item => item.info.authorId === authorId);
            }
        },

        DELETE_FOR_MODEL: function (state, modelId) {
            state.items = _.omitBy(state.items, item => item.location.modelId === modelId);
        },

        CHANGE_TEXT: function (state, payload) {
            state.items[payload.id].info.text = payload.text;
        },

        UPDATE_SEE_THROUGH: function (state, seeThrough) {
            state.seeThrough = seeThrough;
        }
    },

    actions: {
        add: function ({commit}, payload) {
            const modelObject = getModelObject(payload.location.modelId);
            if (payload && payload.location && payload.location.branchId
                && (modelObject.meshType === MeshTypeEnum.POINT_CLOUD || modelManager.getVolume(payload.location.branchId))) {
                commit('garbage_can/INIT_TRIGGER_FOR_VOLUME', payload.location.branchId, {root: true});
                commit('ADD', payload);
            }
        },

        deleteAll: function ({ dispatch }, excludeHelperObjects = false) {
            for (let modelId of modelManager.getAllModelsId()) {
                if (excludeHelperObjects && modelManager.getModelType(modelId) === ModelTypeEnum.HELPER_OBJECT) {
                    continue;
                }
                dispatch('deleteByModel', modelId);
            }
        },

        deleteByModel: function ({commit}, modelId) {
            commit('DELETE_FOR_MODEL', modelId);
            commit('garbage_can/REMOVE_TRIGGER_FOR_MODEL', modelId, {root: true});
        }
    },

    getters: {
        getAllAnnotationsAddedModelIds(state) {
            let modelIds = new Set();
            let annotations = Object.keys(state.items).map((key) => state.items[key]);
            annotations.forEach(item => {
                modelIds.add(item.location.modelId);
            });

            return [...modelIds];
        },

        getAllAnnotations(state) {
            let annotations = [];
            let items = Object.keys(state.items).map((key) => state.items[key]);
            items.forEach(item => {
                if (item.location.modelId) {
                    annotations.push(item);
                }
            });

            return [...annotations];
        },

        getSeeThroughValue(state) {
            return state.seeThrough;
        }
    }
};


export default function register(rootStore) {
    rootStore.registerModule('annotation', store);
}
